import { from, HttpLink, split } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { GetToken, SignOut } from "@clerk/types";
import { getGraphqlURI } from "@/lib/apollo/apollo.utils";
import { fetchUsingMoxieMobile } from "@/lib/moxieMobile/fetchUsingMoxieMobile";
import { getAuthLink } from "./authLink";
import { getErrorLink } from "./errorLink";
import { getWsLink } from "./wsLink";

export function getClientTransportLayerLink({
  getClerkToken,
  isMobileApp,
  signOut,
}: {
  getClerkToken: GetToken;
  isMobileApp: boolean;
  signOut?: SignOut;
}) {
  const authLink = getAuthLink(getClerkToken);
  const errorLink = getErrorLink(signOut);

  const httpLink = from([
    authLink,
    errorLink,
    new HttpLink({
      uri: getGraphqlURI(),
      credentials: "include",
      fetchOptions: {
        mode: "cors",
      },
      ...(isMobileApp && { fetch: fetchUsingMoxieMobile }),
    }),
  ]);

  return split(
    ({ query }) => {
      const definition = getMainDefinition(query);

      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    getWsLink(getClerkToken),
    httpLink
  );
}

export function getServerTransportLayerLink({
  getClerkToken,
  signOut,
}: {
  getClerkToken: GetToken;
  signOut?: SignOut;
}) {
  const authLink = getAuthLink(getClerkToken);
  const errorLink = getErrorLink(signOut);

  return from([
    authLink,
    errorLink,
    new HttpLink({
      uri: getGraphqlURI(),
      credentials: "include",
      fetchOptions: {
        mode: "cors",
      },
    }),
  ]);
}
